// ------------------------------------------
// カート価格計算モジュール
// 純粋な計算処理のみを提供（DOM操作なし）
// ------------------------------------------

/**
 * 日本円の通貨フォーマッター
 * - 円記号（¥）とカンマ区切りで表示
 * - 小数点以下は表示しない
 *
 * @example
 * currencyFormatter.format(5500) // "5,500円"
 * currencyFormatter.format(123456) // "123,456円"
 */
const currencyFormatter = {
  format: (value) => {
    const roundedValue = Math.round(value);
    const formatted = new Intl.NumberFormat('ja-JP', {
      minimumFractionDigits: 0
    }).format(roundedValue);
    return `${formatted}円`;
  }
};

/**
 * カート価格情報を計算
 *
 * @param {Object} cartData - Cart API のレスポンスデータ
 * @param {number} taxRate - 税率（1.1 = 10%）
 * @param {number} freeShippingPrice - 送料無料基準額（cents単位）
 * @returns {Object} 計算結果
 */
function calculateCartPrices(cartData, taxRate, freeShippingPrice) {
  // 税抜き合計（cents 単位）
  const subtotalExcludingTax = cartData.total_price || 0;

  // 税込み合計（税抜き × 税率、円単位で計算してから四捨五入）
  const subtotalIncludingTax = Math.round((subtotalExcludingTax / 100) * taxRate);

  // 送料無料まで残り金額（0円未満にはならない）
  const remainingAmount = Math.max(0, freeShippingPrice - (subtotalIncludingTax * 100));

  // 表示用にフォーマット
  const subtotalExcludingTaxDisplay = currencyFormatter.format(subtotalExcludingTax / 100);
  const subtotalIncludingTaxDisplay = currencyFormatter.format(subtotalIncludingTax);
  const remainingAmountDisplay = currencyFormatter.format(remainingAmount / 100);

  return {
    // 生の値（cents 単位）
    subtotalExcludingTax,
    subtotalIncludingTax: subtotalIncludingTax * 100, // cents に戻す
    remainingAmount,

    // フォーマット済み文字列
    subtotalExcludingTaxDisplay,
    subtotalIncludingTaxDisplay,
    remainingAmountDisplay,

    // 送料無料達成フラグ
    isFreeShipping: remainingAmount === 0
  };
}
